import { FaPlay } from 'react-icons/fa';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const CardH = ({ data, number, eventDataLayer }) => {
  const category = data?.section ? data?.section?.th : 'ข่าว';
  return (
    <div
      className='card-video-h'
      //! DATALAYER
      onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
    >
      <div className='video-number'>{number}</div>
      <div className='play-card-live'>
        <FaPlay className='position-absolute button-card-live' />
        <div className='box-live'>
          <img className='video-thumbnail' src={data?.image} alt={data?.title} />
        </div>
      </div>
      <div className='video-info'>
        <h2>{data?.title}</h2>
        <div className='d-flex video-meta'>
          <div>
            <span className='video-duration'>
              {category}
              {/* {data?.duration === null ? '' : data?.duration.slice(2, -1).replace('M', ':')} */}
            </span>
          </div>
          <div>
            <span className='video-remore'>
              <a href={data.link}> อ่านต่อ...</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardH;
